angular.module("NiabCufApp").factory("FieldPlotCropFactory", ["$resource", function ($resource) {
    return $resource("api/v1.0/khutils/fieldplotcrops/:field_plot_crop_slug/");
}]);